import classNames from 'classnames';
import FJEraseIcon from '../../../assets/svg/erase.svg?react';
import FJDrawIcon from '../../../assets/svg/draw.svg?react';
import PropTypes from 'prop-types';
import styles from './FJBrushCardThree.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import { MOUSE_EVENT_TYPE } from '../../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJValueInput from '../FJValueInput/FJValueInput';
import FJSlider from '../FJSlider/FJSlider';
import { useCallback } from 'react';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJEvent from '../../../store/FJEvent';

const MAX_SIZE = 100;
const MIN_SIZE = 2;

const FJBrushCardThree = props => {
    const {
        disabled,
        brashSize = 0,
        curBrushType,

        minBrashSize = MIN_SIZE,
        maxBrashSize = MAX_SIZE,

        isMouseMove,
        isSlideCompare,

        className,

        changeBrushType,
        changeBrashSize,
        applyOnClick,
        cancelOnClick,
    } = props;

    const mouseDownPanel = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    }, []);

    return (
        <div
            className={classNames(
                styles.container,
                styles.object_erase_container,
                disabled && styles.disabled,
                className,
            )}
            onMouseDown={mouseDownPanel}
        >
            <div className={styles.title}>{FJLocalStore._('refine')}</div>
            <div className={classNames(styles.content_box)}>
                <div className={styles.btu_box}>
                    <div className={styles.erase_edit_btn_box}>
                        <FJHoverBoardGradation
                            className={classNames(styles.edit_btn, {
                                [styles.edit_btn_hover]: !(
                                    curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE &&
                                    !isMouseMove &&
                                    !isSlideCompare
                                ),
                            })}
                            contentClassName={styles.btn}
                            active={curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE && !isMouseMove && !isSlideCompare}
                            onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_ERASE)}
                        >
                            <FJEraseIcon className={styles.erase_icon} />
                            <span className={styles.btn_text}>{FJLocalStore._('erase')}</span>
                        </FJHoverBoardGradation>
                    </div>

                    <FJHoverBoardGradation
                        className={classNames(styles.edit_btn, {
                            [styles.edit_btn_hover]: !(
                                curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW &&
                                !isMouseMove &&
                                !isSlideCompare
                            ),
                        })}
                        contentClassName={styles.btn}
                        active={curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW && !isMouseMove && !isSlideCompare}
                        onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_DRAW)}
                    >
                        <FJDrawIcon className={styles.draw_icon} />
                        <span className={styles.btn_text}>{FJLocalStore._('restore')}</span>
                    </FJHoverBoardGradation>
                </div>

                <div
                    className={classNames(styles.edit_box, {
                        [styles.edit_box_hide]: curBrushType === MOUSE_EVENT_TYPE.NONE,
                    })}
                >
                    <div className={classNames(styles.slider_box, {})}>
                        <div className={styles.slider_text}>
                            <div className={styles.slider_text_item}>{FJLocalStore._('size')}</div>
                            <FJValueInput
                                max={maxBrashSize}
                                min={minBrashSize}
                                value={brashSize}
                                changeValue={changeBrashSize}
                                className={styles.slider_input}
                            />
                        </div>
                        <FJSlider
                            className={styles.slider}
                            max={maxBrashSize}
                            min={minBrashSize}
                            value={brashSize}
                            onChange={changeBrashSize}
                        />
                    </div>

                    <div className={styles.apply_and_cancel_box}>
                        <div className={styles.cancel_btn} onClick={cancelOnClick}>
                            {FJLocalStore._('cancel')}
                        </div>
                        <div className={styles.apply_btn} onClick={applyOnClick}>
                            <div className={styles.apply_btn_text}>{FJLocalStore._('apply')}</div>
                            <div className={styles.apply_btn_hover}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

FJBrushCardThree.propTypes = {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    brashSize: PropTypes.number,
    curBrushType: PropTypes.string,
    minBrashSize: PropTypes.number,
    maxBrashSize: PropTypes.number,
    isMouseMove: PropTypes.bool,
    isSlideCompare: PropTypes.bool,
    changeBrushType: PropTypes.func,
    changeBrashSize: PropTypes.func,
    className: PropTypes.string,
    applyOnClick: PropTypes.func,
    cancelOnClick: PropTypes.func,
};

export default FJBrushCardThree;
